import { c as _c } from "react/compiler-runtime";
export const LivePlayer = t0 => {
  const $ = _c(5);
  const {
    show,
    src
  } = t0;
  if (!show) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      background: "var(--color-header-background-top)",
      padding: "20px",
      margin: 0
    };
    t2 = {
      aspectRatio: "16/9",
      flex: 1,
      maxWidth: "640px",
      margin: "0 auto"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      border: 0
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== src) {
    t4 = <section style={t1}><div style={t2}><iframe src={src} title="Live TV" width="100%" height="100%" frameBorder="0" style={t3} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} /></div></section>;
    $[3] = src;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};